module.exports = __webpack_public_path__ + "static/media/3.ccc0d4aa.jpg";